import { render, staticRenderFns } from "./bookmark-outline.vue?vue&type=template&id=76686a86"
import script from "./bookmark-outline.vue?vue&type=script&lang=js"
export * from "./bookmark-outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports